// i18next-extract-mark-ns-start HowItWorks
import { TFunction } from '../../../types/t-types';

interface StepsType {
  number: number;
  subtitle: string;
  text: string;
}

export interface StepDataType {
  slug: string;
  part1: string;
  part2: string;
  part3?: string;
}

export const introHowItWorksData = (t: TFunction): StepsType[] => [
  {
    number: 1,
    subtitle: t('Réalisez \nvotre diagnostic'),
    text: t('Indiquez le type de prestation que vous souhaitez sur votre pièce et obtenez une première estimation'),
  },
  {
    number: 2,
    subtitle: t('Confiez vos pièces \nà nos artisans'),
    text: t('Envoyez vos articles à nos ateliers parisiens ou réservez un rendez-vous à domicile (si l’un de nos artisans est disponible)'),
  },
  {
    number: 3,
    subtitle: t('Reportez vos \npièces sublimées'),
    text: t('Validez le devis final avec votre artisan et récupérez vos articles sous 3 à 15 jours.'),
  },
];

export const atHomeMoreHowItWorksData = (t: TFunction): StepDataType[] => [
  {
    slug: 'atHomeStep-1',
    part1: t('Selon vos besoins et vos disponibilités, nous confions votre demande à l’un de nos <bold>couturiers professionnels.<bold>'),
    part2: t('Vous recevrez ensuite un mail de confirmation vous indiquant <bold>la date et l’horaire du rendez-vous.<bold>'),
  },
  {
    slug: 'atHomeStep-2',
    part1: t('Le jour du rendez-vous, votre couturier arrive <bold>directement chez vous<bold> afin de prendre vos mesures et vous conseiller au mieux.'),
    part2: t('Lors de ce rendez-vous, vous aurez la possibilité <bold>d’ajouter ou de retirer des vêtements<bold> comme bon vous semble.'),
    part3: t('Vous ne serez débité du montant total de votre commande qu’à la suite de ce premier rendez-vous'),
  },
  {
    slug: 'atHomeStep-3',
    part1: t('Votre Tilliste vous rapporte vos vêtements retouchés au lieu convenu lors du premier rendez-vous, <bold>à date et heure préalablement fixées.<bold>'),
    part2: t('Après vous être assuré que tout vous convient parfaitement, <bold>profitez de vos articles !<bold>'),
    part3: t('Au cas où des ajustements sont nécessaires, votre Tilliste s’en occupera avant de vous les remettre définitivement.'),
  },
];

export const packageMoreHowItWorksData = (t: TFunction): StepDataType[] => [
  {
    slug: 'packageStep-1',
    part1: t('Une fois votre commande validée, vous recevez le <bold>bordereau d’affranchissement<bold> de votre colis par mail.'),
    part2: t('Glissez vos pièces dans un carton et collez l’étiquette d’affranchissement à l’extérieur. Déposez ensuite votre colis dans <bold>le point relais choisi.<bold>'),
    part3: t('Pour réduire les coûts de transport, nous vous conseillons de regrouper vos pièces avec celles de vos proches, amis ou voisins ;)'),
  },
  {
    slug: 'packageStep-2',
    part1: t('Nous vous informons dès que notre atelier a réceptionné vos pièces, puis nos Tillistes se chargent de valider le devis final avec vous.'),
    part2: t('Au cas où <bold>des ajustements sont nécessaires<bold>, votre Tilliste vous contactera par mail ou lors d’un rendez-vous virtuel.'),
  },
  {
    slug: 'packageStep-3',
    // eslint-disable-next-line max-len
    part1: t('Dès que vous avez validé votre devis final, nous réparons et renvoyons vos pièces sous 3 à 5 jours. Vous les recevez dans un délai de 2 à 3 jours ouvrés en point relais ou directement chez vous, en fonction du mode de livraison choisi.'),
    part2: t('<bold>Recevez vos pièces… et c’est parti pour une nouvelle vie !<bold>'),
  },
];

export const stepsPackage = (t: TFunction): StepsType[] => [
  {
    number: 1,
    subtitle: t('Faites le diagnostic \nde vos pièces'),
    text: t(`Réalisez une première estimation sur notre site internet en indiquant le type de pièces et de prestations souhaitées.
      \nRecevez ensuite votre confirmation et votre bordereau d’affranchissement par mail.`),
  },
  {
    number: 2,
    subtitle: t('Postez \nvotre colis'),
    text: t(`Glissez vos pièces dans un carton ou une pochette et collez l’étiquette d’affranchissement à l’extérieur.
      \nDéposez ensuite votre colis dans le point relais choisi.`),
  },
  {
    number: 3,
    subtitle: t('Validez \nle devis final'),
    text: t(`Nous vous informons dès que notre atelier a réceptionné vos pièces.
      \nNos Tillistes valident ensuite le devis avec vous et vous contactent par mail ou en visioconférence si des ajustements sont nécessaires.`),
  },
  {
    number: 4,
    subtitle: t('Réceptionnez \nvos pièces'),
    text: t(`Nous réparons et renvoyons vos pièces sous 7 à 15 jours après validation du devis.
      Vous les recevez en point relais ou chez vous sous 2 à 3 jours ouvrés, selon le mode de livraison choisi.
      \nRecevez vos pièces… et c’est parti pour une nouvelle vie !`),
  },
];

export const stepsAtHome = (t: TFunction, position: string): StepsType[] => [
  {
    number: 1,
    subtitle: t('Prenez rendez-vous à \nl‘adresse et horaire de \nvotre choix'),
    text: t(`Obtenez un devis pour vos retouches et réparations en moins de 2 minutes sur notre site.
      Selon vos besoins et la disponibilité de nos couturiers, Tilli confie votre demande à l’un de ses professionnels.`),
  },
  {
    number: 2,

    subtitle: position ? t('Accueillez votre \ncouturier chez vous à \n{{position}}', { position }) : t('Accueillez votre couturier \nchez vous'),
    // eslint-disable-next-line max-len
    text: t('Le jour du rendez-vous, votre couturier se rend chez vous pour prendre vos mesures, épingler et vous conseiller. Vous pouvez ajouter ou retirer des vêtements librement pendant la visite.'),
  },
  {
    number: 3,
    subtitle: t('Le couturier livre vos \nretouches directement \nchez vous'),
    // eslint-disable-next-line max-len
    text: t('Votre couturier vous livre vos pièces retouchées au lieu convenu lors du premier rendez-vous, à date et heure préalablement fixées. Après vous être assuré que son travail vous convient parfaitement, vous pouvez profiter de vos articles !'),
  },
];
